import { Box, ListItem } from '@chakra-ui/react';
import { ListView } from 'components/molecules/ListView';
import { FC } from 'react';
import { useListStore } from '../../hooks';
import { ApiKeyTemplateListHeader } from './ApiKeyTemplateListHeader';
import { ApiKeyTemplateListItem } from './ApiKeyTemplateListItem';

type UseListStoreReturnType = ReturnType<typeof useListStore>;

type Props = {
  listItems: UseListStoreReturnType['apiKeyTemplates'];
  handleEditOpenModal: UseListStoreReturnType['onOpenModal'];
};

export const ApiKeyTemplateListView: FC<Props> = ({
  listItems,
  handleEditOpenModal,
}) => (
  <>
    <Box m="20px 0 0 0">
      <ApiKeyTemplateListHeader />
    </Box>
    <ListView>
      {listItems.map((item) => (
        <ListItem key={item.id} listStyleType="none">
          <ApiKeyTemplateListItem
            item={item}
            handleClickRow={() => handleEditOpenModal(item)}
          />
        </ListItem>
      ))}
    </ListView>
  </>
);
